import React from 'react';
import Responsive from 'react-responsive';

// Add responsive specific containers for render
export const XsMobile = props => <Responsive {...props} maxWidth={400} />;
export const SmMobile = props => <Responsive {...props} minWidth={401} maxWidth={767} />;
export const Mobile = props => <Responsive {...props} maxWidth={767} />;
export const Desktop = props => <Responsive {...props} minWidth={768} />;

// export const isMobile = toQuery({ query: '(max-width: 768px)' });
export const isMobile = window.matchMedia('(max-width: 768px)').matches;
